import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function CategoryGrid() {
  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <h2 className="font-heading text-xl md:text-3xl font-bold text-foreground-900 mb-3">
              创作分类
            </h2>
            <p className="text-foreground-600 text-sm md:text-base max-w-xl mx-auto">
              五大创作方向，覆盖火影同人的每一个角落，找到属于你的创作天地
            </p>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
            {categories.map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className="group block bg-background-50 rounded-lg p-6 border border-background-200/70 hover:border-primary-300 transition-all duration-300"
              >
                <div className="w-12 h-12 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 mb-4 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors duration-300">
                  <i className={`${cat.icon} text-xl`}></i>
                </div>
                <h3 className="font-heading text-lg font-semibold text-foreground-900 mb-2 group-hover:text-primary-500 transition-colors duration-200">
                  {cat.name}
                </h3>
                <p className="text-foreground-600 text-sm leading-relaxed">
                  {cat.description}
                </p>
                <div className="mt-4 flex items-center gap-1 text-primary-500 text-sm font-medium">
                  <span>浏览文章</span>
                  <i className="ri-arrow-right-line text-xs"></i>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}